import { render, staticRenderFns } from "./HighlightTypesSelector.vue?vue&type=template&id=538b8da1&"
import script from "./HighlightTypesSelector.vue?vue&type=script&lang=js&"
export * from "./HighlightTypesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports